import { render } from "./Invoice.vue?vue&type=template&id=9a660af8&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"

import "./Invoice.vue?vue&type=style&index=0&id=9a660af8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a660af8"]])

export default __exports__